export default __webpack_public_path__ + "static/media/event.b60f114a.svg";